(function () {
  if (window.CitrusImageWithText) {
    window.CitrusImageWithText.init(document);
    return;
  }

  function queryAll(root, selector) {
    var matches = [];
    if (root && root.nodeType === 1 && root.matches(selector)) matches.push(root);
    if (root && root.querySelectorAll) matches = matches.concat(Array.from(root.querySelectorAll(selector)));
    return matches;
  }

  function initScrollToFirst(root) {
    queryAll(root, '.image-text-scroll-to-first[data-scroll-to-first-section]').forEach(function (button) {
      if (button.dataset.imageTextScrollInitialized === 'true') return;
      button.dataset.imageTextScrollInitialized = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();

        var selectors = [
          'main section:first-of-type',
          '.main-content section:first-of-type',
          '.page-content section:first-of-type',
          '.shopify-section:not([data-section-type="header"]):not([data-section-type="announcement-bar"])',
          'section.shopify-section:not([data-section-type="header"])',
          'main > *:first-child',
          '.content section:first-of-type',
          'section:not(header):not([role="banner"])',
          'section:first-of-type',
          '[data-section-type]:not([data-section-type="header"])',
          'main > div:first-child',
          '.main > *:first-child'
        ];
        var target = null;

        for (var index = 0; index < selectors.length; index += 1) {
          target = document.querySelector(selectors[index]);
          if (target) break;
        }

        if (!target) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }

        var headerHeight = (document.querySelector('header') || {}).offsetHeight || 0;
        var stickyHeight = (document.querySelector('.sticky-header, .header-sticky, [style*="position: fixed"]') || {}).offsetHeight || 0;
        var adminHeight = (document.querySelector('#admin_bar_iframe, .admin-bar') || {}).offsetHeight || 0;
        var announcementHeight = (document.querySelector('.announcement-bar, .promo-bar') || {}).offsetHeight || 0;
        var offset = Math.max(headerHeight, stickyHeight) + adminHeight + announcementHeight + 20;

        window.scrollTo({
          top: Math.max(0, target.offsetTop - offset),
          behavior: 'smooth'
        });

        target.style.transition = 'all 0.3s ease';
        target.style.transform = 'scale(1.01)';
        window.setTimeout(function () {
          target.style.transform = 'scale(1)';
        }, 300);
      });
    });
  }

  function initScrollToProduct(root) {
    queryAll(root, '.js-scroll-to-products, [data-scroll-to-product="true"]').forEach(function (button) {
      if (button.dataset.productScrollInitialized === 'true') return;
      button.dataset.productScrollInitialized = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();

        var target = null;
        var targetId = button.getAttribute('href');
        if (targetId && targetId.charAt(0) === '#' && targetId.length > 1) {
          target = document.querySelector(targetId);
        }

        var selectors = [
          '#MainProduct',
          '#shopify-section-product-template',
          '#shopify-section-product',
          '#product-section',
          '.product-section',
          '.product-template',
          '.product-container',
          '.product-main',
          '.product',
          '[data-section-type="product"]',
          '[data-section-id*="product"]',
          'main',
          '#MainContent'
        ];

        for (var index = 0; !target && index < selectors.length; index += 1) {
          target = document.querySelector(selectors[index]);
        }

        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initAccordions(root) {
    queryAll(root, '.image-text-section .accordion-items-wrapper').forEach(function (container) {
      var items = Array.from(container.querySelectorAll('.accordion-item'));
      var accordionMode = container.getAttribute('data-accordion-mode') === 'true';

      items.forEach(function (item) {
        var header = item.querySelector('.accordion-header');
        var content = item.querySelector('.accordion-content');
        if (!header || !content || header.hasAttribute('data-accordion-initialized')) return;

        var toggleItem = function (event) {
          event.preventDefault();
          event.stopPropagation();

          var isActive = item.classList.contains('active');
          if (accordionMode && !isActive) {
            items.forEach(function (otherItem) {
              if (otherItem !== item) otherItem.classList.remove('active');
            });
          }

          item.classList.toggle('active', !isActive);
          container.dispatchEvent(new CustomEvent('accordion:toggle', {
            detail: {
              item: item,
              isOpen: !isActive,
              text: (header.querySelector('.accordion-header-text') || {}).textContent
            }
          }));
        };

        header.addEventListener('click', toggleItem);
        header.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') toggleItem(event);
        });
        header.setAttribute('data-accordion-initialized', 'true');
        header.style.cursor = 'pointer';
        if (!header.hasAttribute('tabindex')) header.setAttribute('tabindex', '0');
      });
    });
  }

  function initVideos(root) {
    queryAll(root, '.image-text-section .main-video[data-autoplay-in-view="true"]').forEach(function (video) {
      if (video.dataset.inViewVideoInitialized === 'true') return;
      video.dataset.inViewVideoInitialized = 'true';
      video.preload = 'none';

      if (!('IntersectionObserver' in window)) {
        video.play().catch(function () {});
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { rootMargin: '100px 0px', threshold: 0.15 });

      observer.observe(video);
    });
  }

  function init(root) {
    var scope = root || document;
    initScrollToFirst(scope);
    initScrollToProduct(scope);
    initAccordions(scope);
    initVideos(scope);
  }

  window.CitrusImageWithText = { init: init };
  window.debugAccordion = {
    init: function () { initAccordions(document); },
    test: function () {
      var item = document.querySelector('.image-text-section .accordion-item');
      if (!item) return false;
      item.classList.toggle('active');
      return true;
    },
    toggle: function (index) {
      var items = document.querySelectorAll('.image-text-section .accordion-item');
      if (items[index]) items[index].classList.toggle('active');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
}());
